import { createSlice } from '@reduxjs/toolkit'
import helper from '../../Helper';
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
    loading: false,
    getUserStatistics: [],
    overAllStatisstics: [],
    error: "",
}

const statisticsSlice = createSlice({
    name: 'statistics',
    initialState,
    reducers: {
        userStatistics: (state, action) => {
            state.getUserStatistics = action.payload
        },
        statisstics: (state, action) => {
            state.overAllStatisstics = action.payload
        },

    }
})

export const { userStatistics, statisstics } = statisticsSlice.actions;
export default statisticsSlice.reducer;



export const getUserStatistics = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API.GET_USER_STATISTICS}`, data);
            callback(response);
            dispatch(userStatistics(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };


export const getOverAllStatisstics = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.GET_OVERALL_STATISTICS}`, data);
            callback(response);
            dispatch(statisstics(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };